import { createAction, props } from '@ngrx/store';
import { AdvancedFilter } from 'src/app/sharedModule/models/advanced-filter.model';
import { AdvancedFilterRequest } from '../../entities/advanced-filter-request.class';

const actionPrefix = '[Assign][Advanced Filters]';

export const refreshAdvancedFilters = createAction(`${actionPrefix} Refresh Advanced Filters`);
export const refreshAdvancedFiltersSuccess = createAction(
  `${actionPrefix} Refresh Advanced Filters Success`,
  props<{ advancedFilters: AdvancedFilter[] }>(),
);
export const refreshAdvancedFiltersFailure = createAction(`${actionPrefix} Refresh Advanced Filters Failure`);

export const changeCountOrderInFilter = createAction(
  `${actionPrefix} Change Count Order In Filter`,
  props<{ filterId: number; countOrder: number }>(),
);

export const loadCountReadyOrders = createAction(`${actionPrefix} Load Count Ready Orders`);
export const loadCountReadyOrdersSuccess = createAction(
  `${actionPrefix} Load Count Ready Orders Success`,
  props<{ countReadyOrders: number }>(),
);
export const loadCountReadyOrdersFailure = createAction(`${actionPrefix} Load Count Ready Orders Failure`);
export const changeCountReadyOrders = createAction(
  `${actionPrefix} Change Count Ready Orders`,
  props<{ countReadyOrders: number }>(),
);

export const loadCountHoldOrders = createAction(`${actionPrefix} Load Count Hold Orders`);
export const loadCountHoldOrdersSuccess = createAction(
  `${actionPrefix} Load Count Hold Orders Success`,
  props<{ countHoldOrders: number }>(),
);
export const loadCountHoldOrdersFailure = createAction(`${actionPrefix} Load Count Hold Orders Failure`);
export const changeCountHoldOrders = createAction(
  `${actionPrefix} Change Count Hold Orders`,
  props<{ countHoldOrders: number }>(),
);

export const loadCountScheduleOrders = createAction(`${actionPrefix} Load Count Schedule Orders`);
export const loadCountScheduleOrdersSuccess = createAction(
  `${actionPrefix} Load Count Schedule Orders Success`,
  props<{ countScheduleOrders: number }>(),
);
export const loadCountScheduleOrdersFailure = createAction(`${actionPrefix} Load Count Schedule Orders Failure`);
export const changeCountScheduleOrders = createAction(
  `${actionPrefix} Change Count Schedule Orders`,
  props<{ countScheduleOrders: number }>(),
);

export const deleteAdvancedFilter = createAction(
  `${actionPrefix} Delete Advanced Filter`,
  props<{ filterId: number }>(),
);
export const deleteAdvancedFilterSuccess = createAction(
  `${actionPrefix} Delete Advanced Filter Success`,
  props<{ filterId: number }>(),
);
export const deleteAdvancedFilterFailure = createAction(`${actionPrefix} Delete Advanced Filter Failure`);

export const addAdvancedFilter = createAction(
  `${actionPrefix} Add Advanced Filter`,
  props<{ filterRequest: AdvancedFilterRequest }>(),
);
export const addAdvancedFilterSuccess = createAction(
  `${actionPrefix} Add Advanced Filter Success`,
  props<{ filter: AdvancedFilter }>(),
);
export const addAdvancedFilterFailure = createAction(`${actionPrefix} Add Advanced Filter Failure`);
